import PropTypes from "prop-types";
import {Constants} from "../../controllers/Constants";

export function Message(props) {
	return (
		<div
			className={`message ${props.className}`}
			style={{...props.style}}
			onClick={props.onClick}
		>
			{props.children}
		</div>
	);
}


Message.propTypes = {style: PropTypes.object, className:PropTypes.string, onClick:PropTypes.func}
Message.defaultProps = {style: null, className:'', onClick:null}
